<script>
import { InteractiveVideo } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      lookupKwarg: 'slug',
      editRouteName: 'Edit InteractiveVideo',
      addRoute: { name: 'Add InteractiveVideo' },
      verboseName: 'wideo interaktywne',
      verboseNamePlural: 'wideo interaktywne',
      listFields: [
        { prop: 'slug', label: 'slug' },
        { prop: 'name', label: 'nazwa' }
      ]
    }
  },
  computed: {
    service() {
      return InteractiveVideo
    }
  }
}
</script>
